import React from 'react';

import styles from './styles.module.scss';
import {BottomCard} from '../../../components/Cards/BottomCard';
import {EncryptedCard} from '../../../components/Cards/EncryptedCard';
import {CustomisationCard} from '../../../components/Cards/CustomisationCard';
import {WhiteListCard} from '../../../components/Cards/WhiteListCard';
import {ModerationCard} from '../../../components/Cards/ModerationCard';
import {LocalisationCard} from '../../../components/Cards/LocalisationCard';
import {WhitelabelCard} from '../../../components/Cards/WhitelabelCard';
import {SupportCard} from '../../../components/Cards/SupportCard';

export const Glance = () => {
  return (
    <div className={styles.glance}>
      <div className={styles.container}>
        <h3 className={styles.title}>At a glance</h3>
        <p className={styles.subtitle}>
          Our company and products are designed based on 4 core values:
        </p>

        <div className={styles.cardsWrapper}>
          <EncryptedCard />
          <CustomisationCard />
          <WhiteListCard />
          <ModerationCard />
          <LocalisationCard />
          <WhitelabelCard />
          <SupportCard />
        </div>
        <div className={styles.bottomCard}>
          <BottomCard />
        </div>
      </div>
    </div>
  );
};
